import { z } from 'zod';
import { StrengthTraitSlugListSchema, StrengthTraitSlugSchema } from '../event-feedback/strength-traits';

export const PERSON_DISPLAY_NAME_MAX = 120;

/** Отметка сильной стороны человека: слаг + когда владелец её поставил. */
export const PersonStrengthDto = z.object({
  slug: StrengthTraitSlugSchema,
  markedAt: z.iso.datetime(),
});
export type PersonStrengthDto = z.infer<typeof PersonStrengthDto>;

/** Карточка человека в списке «Мои люди». userId=null — фантом. */
export const PersonDto = z.object({
  id: z.uuid(),
  userId: z.uuid().nullable(),
  displayName: z.string().min(1).max(PERSON_DISPLAY_NAME_MAX),
  telegramUsername: z.string().nullable(),
  isPhantom: z.boolean(),
  invitedAt: z.iso.datetime().nullable(),
  mergedAt: z.iso.datetime().nullable(),
  strengths: z.array(PersonStrengthDto),
  feedbackCount: z.number().int().min(0),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});
export type PersonDto = z.infer<typeof PersonDto>;

export const CreatePersonInput = z.object({
  displayName: z.string().trim().min(1).max(PERSON_DISPLAY_NAME_MAX),
  telegramUsername: z.string().trim().min(1).max(64).optional(),
  /** Указан — карточка сразу на реального юзера, фантом не создаётся. */
  userId: z.uuid().optional(),
});
export type CreatePersonInput = z.infer<typeof CreatePersonInput>;

export const UpdatePersonInput = z
  .object({
    displayName: z.string().trim().min(1).max(PERSON_DISPLAY_NAME_MAX).optional(),
    telegramUsername: z.string().trim().min(1).max(64).nullable().optional(),
  })
  .refine((v) => v.displayName !== undefined || v.telegramUsername !== undefined, {
    message: 'nothing to update',
  });
export type UpdatePersonInput = z.infer<typeof UpdatePersonInput>;

/** Полный набор слагов человека: разница с текущим применяется диффом. */
export const SetPersonStrengthsInput = z.object({ slugs: StrengthTraitSlugListSchema });
export type SetPersonStrengthsInput = z.infer<typeof SetPersonStrengthsInput>;

export const PersonInviteDto = z.object({
  personId: z.uuid(),
  inviteCode: z.string().length(8),
  url: z.url(),
  invitedAt: z.iso.datetime(),
});
export type PersonInviteDto = z.infer<typeof PersonInviteDto>;
